<!-- @format -->

@if (!belowMinimumRecommendations() && productRecommendations()?.length > 0) {
	<div
		id="pdp-ds-product-recommendations"
		[class]="{
			'hmf-mb-m-l': isPLA() && !homefieldCarouselEnabled(),
			'p hmf-mb-l hmf-mb-m-xl': !homefieldCarouselEnabled(),
			'hmf-p-m': addPadding(),
			'hmf-mb-xxs': shouldApplyPlaCarouselDefaultMargin(),
			'prehydration-margin': shouldApplyPlaCarouselPreHydrationMargin(),
			'product-recommendations-name-clamp': true,
			'product-recommendations-pla': isPLA()
		}"
		class="product-recommendations">
		<!-- Recommendation Heading -->
		@if (showHeading()) {
			<div
				[class]="{
					'hmf-mb-m':
						!enableRepositionRecommendations() &&
						!isPLA() &&
						!homefieldCarouselEnabled(),
					'hmf-mb-s': isPLA(),
					'product-recommendations-header': isUpperCase(),
					'hmf-header-bold-s': !isUpperCase(),
					'hmf-text-transform-uppercase': isUpperCase(),
					'hmf-mb-xxxs hmf-ml-xs': homefieldCarouselEnabled()
				}">
				<span [class]="{ capitalized: capitalizeTitle() }">{{ displayName() }}</span>
				@if (showViewAllLink()) {
					<hr class="header-hr" />
				}
				@if (showViewAllLink()) {
					<a
						href="/s/recommended-for-you"
						class="hmf-ml-xxs viewall"
						data-em="PDP_CertonaViewAllpdplanding_rr"
						>View All</a
					>
				}
			</div>
		}
		@if (homefieldCarouselEnabled()) {
			<!-- Homefield Cart Recommendations -->
			<hmf-carousel
				actionButtonTitle="View All"
				[title]="title() ? title() : ''"
				[showHeader]="showHeader()"
				[showActionButton]="showViewAllLink()"
				[showScrollButtons]="showScrollButtons()"
				[showScrollButtonsOnMobile]="showScrollButtonsOnMobile()"
				(actionButtonClicked)="goToRecommendedForYouDS()">
				@for (
					itemRecomendation of productRecommendations();
					let index = $index;
					let isLast = $last;
					track trackByName(index, itemRecomendation)
				) {
					<div [class.pla-carousel-item]="isPLA()">
						@if (index < dsRecsProductDisplayLimit()) {
							<hmf-product-card
								class="cursor-pointer"
								buttonStyle="secondary"
								[buttonText]="atcButtonTexts.atc"
								[class.hmf-mr-xs]="!isLast && this.pageType() === 'Cart'"
								[productData]="mapItemToProductCardData(itemRecomendation)"
								[showATC]="showATC"
								[showReviewsStars]="false"
								[size]="getProductCardSize()"
								variant="recommendation"
								(cardClicked)="onRecommendationLinkClick(itemRecomendation, index)"
								(addToCartClicked)="
									onAddToCartButtonClick(itemRecomendation, index)
								">
							</hmf-product-card>
						}
					</div>
				}
			</hmf-carousel>
		} @else {
			<!-- Legacy Cart Recommendations -->
			<div>
				<div
					class="hmf-display-flex hmf-flex-row cart-product-recommendation-card-container"
					[class]="{
						'hmf-pt-s': enableRepositionRecommendations(),
						'hmf-pt-0 hmf-pb-xxs': isPLA()
					}">
					@for (item of productRecommendations(); track $index + item?.name) {
						@let index = $index;
						@if (item) {
							<div
								class="product-recommendation dcsg-card"
								[class]="{ 'hmf-p-s': isPLA() }"
								[class.small-mobile-product-recommendations]="
									smallLegacyMobileCard()
								">
								<span
									class="hmf-display-flex hmf-flex-column hmf-justify-content-evenly hmf-h-100">
								<a
									class="product-recommendation-content hmf-display-flex hmf-flex-column hmf-align-items-stretch hmf-align-self-stretch url"
									[class]="{
										'product-recommendation-content-height': !isPLA()
									}"
									[href]="getRecommendationUrl(item, index)"
									(click)="onRecommendationLinkClick(item, index)">
										<img
											class="hmf-align-self-center cross-sell-img product-image"
											[class]="{ 'hmf-mb-0': isPLA() }"
											loading="lazy"
											[src]="$safeNavigationMigration(item?.image)"
											[alt]="item?.seo?.imageAltDesc || item?.name" />
										<div
											class="cross-sell-desc product-name line-clamp hmf-align-self-start">
											<span [innerHTML]="$safeNavigationMigration(item?.name)"></span>
										</div>
										<div class="list-view-item-price hmf-align-self-start">
											<!-- "see price in cart" scenario -->
											@if (
												(!item?.prices?.minofferprice &&
													!item?.prices?.maxofferprice) ||
												item?.prices?.mapPriceIndicator === 1
											) {
												<span>See Price In Cart</span>
											}
											<!-- NOT "see price in cart" scenario -->
											@if (
												!(
													(!item?.prices?.minofferprice &&
														!item?.prices?.maxofferprice) ||
													item?.prices?.mapPriceIndicator === 1
												)
											) {
												<div>
													<span>{{
														$safeNavigationMigration(item?.prices?.minofferprice) | currency
													}}</span>
													@if (
														item?.prices?.minofferprice !==
														item?.prices?.maxofferprice
													) {
														<span
															>&nbsp;to&nbsp;{{
																$safeNavigationMigration(item?.prices?.maxofferprice)
																	| currency
															}}</span
														>
													}
												</div>
											}
										</div>
									</a>
									@if (showATC) {
										<div class="hmf-w-100 rec-atc">
											<button
												hmf-button
												variant="tertiary"
												class="rec-atc-btn"
												(click)="onAddToCartButtonClick(item, index)">
												{{ atcButtonTexts.atc }}
											</button>
										</div>
									}
								</span>
							</div>
						} @else {
							<hmf-skeleton
								[class.hmf-display-none]="smallLegacyMobileCard()"
								[class.hmf-display-md-block]="smallLegacyMobileCard()"
								[loading]="!item"
								height="239px"
								width="200px" />
							@if (smallLegacyMobileCard()) {
								<hmf-skeleton
									class="hmf-display-block hmf-display-md-none"
									[loading]="!item"
									height="195px"
									width="144px" />
							}
						}
					}
				</div>
			</div>
		}
	</div>
}
